const appConfig = {
  apiPrefix: "https://vaishnaviprofile-pvt-ltd.5techg.com/api/",

  // apiPrefix: "http://localhost:5004/api/",
  authenticatedEntryPath: "/dashboard",
  unAuthenticatedEntryPath: "/sign-in",
  tourPath: "/",
  locale: "en",
  enableMock: true,
};

export default appConfig;
